import { VALIDATION_RULES } from '@/shared/lib/constants/form';

/**
 * HTML 태그를 제거하고 순수 텍스트를 추출합니다.
 * @param html - HTML 문자열
 * @returns 순수 텍스트 (공백 제거됨)
 */
export const getTextFromHtml = (html?: string | null): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
};

/**
 * Description의 길이가 최소/최대 길이 요구사항을 충족하는지 검증합니다.
 * @param description - 검증할 description (HTML 포함 가능)
 * @param minLength - 최소 길이 (기본값: 30)
 * @param maxLength - 최대 길이 (기본값: 300)
 * @returns 검증 통과 여부
 */
export const validateDescriptionLength = (
  description?: string | null,
  minLength: number = VALIDATION_RULES.DESCRIPTION_MIN_LENGTH,
  maxLength: number = VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
): boolean => {
  const text = getTextFromHtml(description);
  return text.length >= minLength && text.length <= maxLength;
};

/**
 * Description의 순수 텍스트 길이를 반환합니다.
 * @param description - description (HTML 포함 가능)
 * @returns 순수 텍스트 길이
 */
export const getDescriptionTextLength = (description?: string | null): number => {
  const text = getTextFromHtml(description);
  return text.length;
};
